import * as React from "react";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
// import CloseIcon from "@mui/icons-material/Close";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { IoCloseSharp } from "react-icons/io5";

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

export default function FilterChips() {
  const [chipData, setChipData] = React.useState([
    { key: 0, label: "Angular" },
    { key: 1, label: "jQuery" },
    { key: 2, label: "Polymer" },
    { key: 3, label: "React" },
    { key: 4, label: "Vue.js" },
  ]);

  const handleDelete = (chipToDelete) => {
    setChipData((chips) =>
      chips.filter((chip) => chip.key !== chipToDelete.key)
    );
  };

  return (
    <Paper
      sx={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        listStyle: "none",
        p: 0,
        m: 0,
      }}
      component="ul"
      className="!shadow-none"
    >
      {chipData.map((data) => {
        // let icon = ;
        return (
          <ListItem
            key={data.key}
            className=" bg-[#239403] text-white rounded-[20px] pb-2 pt-[6px] px-4 flex items-center text-center gap-1"
          >
            {/* <Chip
              className=" child_remove_bg"
              //   icon={CloseSharpIcon}
              label={data.label}
              onDelete={handleDelete(data)}
              variant="outlined"
            /> */}

            <p>{data.label}</p>
            <IoCloseSharp
              title="Remove"
              className="!bg-none !text-white text-[15px] h-[22px] w-[22px]  cursor-pointer relative  z-50"
              onClick={() => {
                handleDelete(data);
              }}
            />
          </ListItem>
        );
      })}
    </Paper>
  );
}
